<template>
  <div>
    <el-page-header @back="goBack" content="试题管理"> </el-page-header>
    <div
      style="
        width: 1300px;
        margin: 20px auto;
        font-size: 30px;
        font-weight: 600;
        text-align: center;
      "
    >
      {{ title }}
    </div>
    <el-card style="width: 1300px; margin: 30px auto 0">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="keys" placeholder="请输入题目" size="medium" clearable
                @keyup.enter.native="getQuestion"></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" size="medium" @click="getQuestion"
            >查询</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button type="success" size="medium" @click="addQuestion"
            >添加试题</el-button
          >
        </el-col>
      </el-row>
      <div class="question" v-if="choiceList.length != 0">一.选择题</div>
      <div
        class="question_content"
        v-for="(item, index) of choiceList"
        :key="item.id"
      >
        <div class="question_title">
          {{ index + 1 }}.{{ item.title }}（{{ item.score }}分）
          <el-tag type="danger" v-if="item.state == 0" size="mini"
            >未发布</el-tag
          >
        </div>
        <div class="question_operation">
          <el-button type="primary" size="mini" @click="EditQuestion(item)"
            >修改题目</el-button
          >
          <el-button
            type="success"
            size="mini"
            v-if="item.state == 0"
            @click="changeState(item, 1)"
            >发布</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-else
            @click="changeState(item, 0)"
            >下架</el-button
          >
          <el-button type="danger" size="mini" @click="deleteQuestion(item)"
            >删除</el-button
          >
          <el-button type="success" size="mini" @click="addAnswers(item)"
            >添加答案</el-button
          >
        </div>
        <div style="clear: both"></div>
        <div
          class="answers"
          v-for="item1 of item.answers"
          :key="item1.answerid"
        >
          <div class="answers_content">
            {{ item1.sm }}.{{ item1.answerdetail
            }}<el-tag type="success" v-if="item1.isright == 1" size="mini"
              >正确答案</el-tag
            >
          </div>
          <div class="answers_opearation">
            <el-button type="text" @click="editAnswer(item1)">修改</el-button>
            <el-button type="text" @click="deleteAnswer(item1)">删除</el-button>
            <el-button
              type="text"
              v-if="item1.isright != 1"
              @click="setRight(item1, 1)"
              >设为正确答案</el-button
            >
            <el-button type="text" v-else @click="setRight(item1, 0)"
              >取消正确答案</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="question"
        v-if="choiceList.length == 0 && judgmentList.length != 0"
      >
        一.判断题
      </div>
      <div
        class="question"
        v-if="choiceList.length != 0 && judgmentList.length != 0"
      >
        二.判断题
      </div>
      <div
        class="question_content"
        v-for="(item, index2) of judgmentList"
        :key="item.id"
      >
        <div class="question_title">
          {{ index2 + 1 }}.{{ item.title }}（{{ item.score }}分）
          <el-tag type="danger" v-if="item.state == 0" size="mini"
            >未发布</el-tag
          >
        </div>
        <div class="question_operation">
          <el-button type="primary" size="mini" @click="EditQuestion(item)"
            >修改题目</el-button
          >
          <el-button
            type="success"
            size="mini"
            v-if="item.state == 0"
            @click="changeState(item, 1)"
            >发布</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-else
            @click="changeState(item, 0)"
            >下架</el-button
          >
          <el-button type="danger" size="mini" @click="deleteQuestion(item)"
            >删除</el-button
          >
          <el-button type="success" size="mini" @click="addAnswers(item)"
            >添加答案</el-button
          >
        </div>
        <div style="clear: both"></div>
        <div
          class="answers"
          v-for="item1 of item.answers"
          :key="item1.answerid"
        >
          <div class="answers_content">
            {{ item1.sm }}.{{ item1.answerdetail }}
            <el-tag type="success" v-if="item1.isright == 1" size="mini"
              >正确答案</el-tag
            >
          </div>
          <div class="answers_opearation">
            <el-button type="text" @click="editAnswer(item1)">修改</el-button>
            <el-button type="text" @click="deleteAnswer(item1)">删除</el-button>
            <el-button
              type="text"
              v-if="item1.isright != 1"
              @click="setRight(item1, 1)"
              >设为正确答案</el-button
            >
            <el-button type="text" v-else @click="setRight(item1, 0)"
              >取消正确答案</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加试题' : '修改试题'"
      :visible.sync="dialogquestions"
      :width="'1000px'"
      :close-on-click-modal="false"
      center
    >
      <el-form :model="formQuestion" label-width="100px">
        <el-form-item label="试题类型：">
          <el-select v-model="formQuestion.tmlxid" placeholder="请选择试题类型">
            <el-option
              v-for="(item, index) of tmlxList"
              :key="index"
              :label="item.lx"
              :value="item.tmlxid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题内容：">
          <el-input v-model="formQuestion.title"></el-input>
        </el-form-item>
        <el-form-item label="试题分数：">
          <el-input v-model.number="formQuestion.score"></el-input>
        </el-form-item>
        <el-form-item label="是否发布：">
          <el-radio-group v-model="formQuestion.state">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-for="(item, index) of formQuestion.answers"
          :key="index"
          :label="'答案' + (index + 1) + '：'"
        >
          <el-input
            v-model="item.sm"
            placeholder="选项名(A,B,C,D...)"
            style="width: 150px"
          ></el-input>
          ：
          <el-input
            v-model="item.answerdetail"
            placeholder="请输入答案内容"
            style="width: 600px"
          ></el-input>
          <el-button type="danger" @click.prevent="removeAnswer(item)"
            >删除</el-button
          >
          <p >
            是否设为正确答案:
            <el-radio-group v-model="item.isright">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </p>
        </el-form-item>
        <el-form-item label="" v-if="isAdd">
          <el-button @click="addAnswer">新增答案</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogquestions = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="isaddAnswer ? '添加答案' : '修改答案'"
      :visible.sync="dialogAnswer"
      :width="'1000px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formAnswer" label-width="140px">
        <el-form-item label="答案：">
          <el-input
            v-model="formAnswer.sm"
            placeholder="选项名(A,B,C,D...)"
            style="width: 150px"
          ></el-input>
          ：
          <el-input
            v-model="formAnswer.answerdetail"
            placeholder="请输入答案内容"
            style="width: 600px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否设为正确答案：">
          <el-radio-group v-model="formAnswer.isright">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogAnswer = false">取 消</el-button>
        <el-button type="primary" @click="submitAnswer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      examid: 0,
      title: "",
      keys: "",
      isAdd: false,
      dialogquestions: false,
      tmlxList: [],
      formQuestion: {
        title: "",
        examid: 0,
        tmlxid: 1,
        state: 0,
        score: 0,
        answers: [],
      },
      choiceList: [],
      judgmentList: [],
      initFrom: {},
      dialogAnswer: false,
      isaddAnswer: false,
      formAnswer: {
        examinationid: 0,
        sm: "",
        answerdetail: "",
        isright: 0,
      },
    };
  },
  mounted() {
    this.initFrom = { ...this.formQuestion };
    this.examid = this.$route.params.examid;
    this.title = this.$route.params.examTitle;
    this.getQuestion();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    //获取题目类型
    getexamlx() {
      this.$http
        .post("Exam/GetSearchList", {
          action: "getexamlx",
          pageIndex: 1,
        })
        .then((res) => {
          if (res.data && res.data.isok) {
            this.tmlxList = res.data.data;
          }
        });
    },
    //获取所有题目
    getQuestion() {
      this.$http
        .post("Exam/GetSearchList", {
          action: "Examination",
          key: this.keys,
          pageIndex: 1,
          id: this.examid,
        })
        .then((res) => {
          if (res.data && res.data.isok) {
            if (res.data.data.length != 0) {
              if (res.data.data.length == 1) {
                if (res.data.data[0].lx == "选择题") {
                  this.choiceList = res.data.data[0].list;
                } else {
                  this.judgmentList = res.data.data[0].list;
                }
              } else {
                this.choiceList = res.data.data[0].list;
                this.judgmentList = res.data.data[1].list;
              }
            }
          }
        });
    },
    addQuestion() {
      this.formQuestion = { ...this.initFrom };
      this.getexamlx();
      this.formQuestion.answers = [];
      this.isAdd = true;
      this.dialogquestions = true;
    },
    submitUp() {
      this.formQuestion.examid = this.examid;
      if (this.isAdd) {
        if (this.formQuestion.answers.length != 0) {
          let arr = this.formQuestion.answers;
          let canSubmit = arr.every((item) => {
            return item.sm != "" && item.answerdetail != "";
          });
          //
          if (canSubmit) {
            this.$http
              .post("/Exam/AddExamination", this.formQuestion)
              .then((res) => {
                if (res.data.isok) {
                  this.$message.success(res.data.message);
                  this.dialogquestions = false;
                  this.getQuestion();
                } else {
                  this.$message.error(res.data.message);
                }
              });
          } else {
            this.$message.error("答案内容不可为空，请重新填写！");
          }
        } else {
          this.$http
            .post("/Exam/AddExamination", this.formQuestion)
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.dialogquestions = false;
                this.getQuestion();
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      } else {
        this.$http
          .post("Exam/UpdateExamination", this.formQuestion)
          .then((res) => {
            if (res.data && res.data.isok) {
              this.$message.success(res.data.message);
              this.dialogquestions = false;
              this.getQuestion();
            } else {
              this.$message.error(res.data.message);
            }
          });
      }
    },
    // 修改题目
    EditQuestion(rows) {
      this.formQuestion = { ...this.initFrom };
      this.formQuestion.answers = [];
      this.isAdd = false;
      this.getexamlx();
      this.formQuestion.tmlxid = rows.tmlxid;
      this.formQuestion.title = rows.title;
      this.formQuestion.score = rows.score;
      this.formQuestion.state = rows.state;
      this.formQuestion.id = rows.id;
      this.dialogquestions = true;
    },
    //上下架题目
    changeState(rows, state) {
      this.$http
        .post("Exam/UpDownExamination", {
          title: rows.title,
          examid: this.examid,
          id: rows.id,
          score: rows.score,
          tmlxid: rows.tmlxid,
          state,
        })
        .then((res) => {
          if (res.data && res.data.isok) {
            this.$message.success(res.data.message);
            this.getQuestion();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 删除题目
    deleteQuestion(rows) {
      this.$confirm("此操作将会永久删除这道题目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Exam/DelExamination", {
              id: rows.id,
            })
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.getQuestion();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //添加单个答案
    addAnswers(rows) {
      this.formAnswer = {
        examinationid: 0,
        sm: "",
        answerdetail: "",
        isright: 0,
      };
      this.isaddAnswer = true;
      this.formAnswer.examinationid = rows.id;
      this.dialogAnswer = true;
    },
    //修改答案
    editAnswer(rows) {
      this.isaddAnswer = false;
      this.formAnswer.examinationid = rows.examinationid;
      this.formAnswer.sm = rows.sm;
      this.formAnswer.answerid = rows.answerid;
      this.formAnswer.answerdetail = rows.answerdetail;
      this.formAnswer.isright = rows.isright;
      this.dialogAnswer = true;
    },
    //确认添加/修改答案
    submitAnswer() {
      if (this.isaddAnswer) {
        this.$http.post("Exam/AddAnswer", this.formAnswer).then((res) => {
          if (res.data && res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogAnswer = false;
            this.getQuestion();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$http.post("Exam/UpdateAnser", this.formAnswer).then((res) => {
          if (res.data && res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogAnswer = false;
            this.getQuestion();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //删除答案
    deleteAnswer(rows) {
      this.$confirm("此操作将会永久删除这个答案, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Exam/DelAnswer", {
              id: rows.answerid,
            })
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.getQuestion();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    setRight(rows, isright) {
      this.$http
        .post("Exam/UpRwAnser", {
          answerid: rows.answerid,
          isright,
        })
        .then((res) => {
          if (res.data && res.data.isok) {
            this.$message.success(res.data.message);
            this.getQuestion();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    removeAnswer(item) {
      var index = this.formQuestion.answers.indexOf(item);
      if (index !== -1) {
        this.formQuestion.answers.splice(index, 1);
      }
    },
    addAnswer() {
      this.formQuestion.answers.push({
        sm: "",
        answerdetail: "",
        isright: 0,
      });
    },
  },
};
</script>

<style lang="less">
.el-page-header {
  margin-left: 30px;
  margin-top: 20px;
}
.question {
  font-size: 20px;
  padding: 15px 0;
  font-weight: 600;
}
.question_title {
  font-size: 16px;
  float: left;
  position: relative;
  margin-bottom: 15px;
}
.question_operation {
  float: right;
}
.question_content {
  padding: 0 30px;
}
.answers {
  padding: 0 200px 0 20px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
button:foucs {
  outline: 0 !important;
}
.question_title > span {
  display: inline-block;
  padding: 0px 2px;
  font-size: 12px;
  position: relative;
  top: -5px;
}
.answers_content > span {
  display: inline-block;
  padding: 0px 2px;
  font-size: 12px;
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/TestQuestions.vue